import { render, staticRenderFns } from "./EmptyAnnotation.vue?vue&type=template&id=4d7d5a4c&scoped=true&"
import script from "./EmptyAnnotation.vue?vue&type=script&lang=js&"
export * from "./EmptyAnnotation.vue?vue&type=script&lang=js&"
import style0 from "../../assets/scss/document_annotations.scss?vue&type=style&index=0&id=4d7d5a4c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7d5a4c",
  null
  
)

export default component.exports